import { CartLinesUpdateEvent } from 'https://cdn.shopify.com/storefront/standard-events.js';

class GntlCrossSell extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('change', this.onChange, { signal: this.controller.signal });
    this.addEventListener('click', this.onClick, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onChange = (event) => {
    const select = event.target.closest('[data-cross-variant]');
    if (!select) return;
    const card = select.closest('[data-cross-card]');
    card.querySelector('[data-cross-add]').disabled = !select.value;
    if (select.value) card.querySelector('[data-cross-price]').textContent = select.selectedOptions[0].dataset.price;
    card.querySelector('[data-cross-status]').textContent = '';
  };

  onClick = async (event) => {
    const button = event.target.closest('[data-cross-add]');
    if (!button || button.disabled || this.busy) return;
    event.preventDefault();
    const card = button.closest('[data-cross-card]');
    const select = card.querySelector('[data-cross-variant]');
    if (!select.value) return;
    this.busy = true;
    button.disabled = true;
    select.disabled = true;
    const status = card.querySelector('[data-cross-status]');
    status.textContent = this.dataset.adding;
    this.setAttribute('aria-busy', 'true');
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
      const response = await fetch(this.dataset.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }], sections, sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      status.textContent = this.dataset.added;
      card.hidden = true;
      let cart;
      try {
        const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch {}
      if (cart) this.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: select.value, quantity: 1 }],
        promise: Promise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            source: 'product-form-component',
            sourceId: 'gntl-cross-sell',
            items: cart.items,
            itemCount: 1,
            sections: result.sections,
            didError: false
          }
        })
      }));
    } catch (error) {
      status.textContent = error.message || this.dataset.error;
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
      button.disabled = !select.value;
      select.disabled = false;
    }
  };
}

if (!customElements.get('gntl-cross-sell')) customElements.define('gntl-cross-sell', GntlCrossSell);
